import { render, staticRenderFns } from "./youjiao.vue?vue&type=template&id=47cb938f&scoped=true"
import script from "./youjiao.vue?vue&type=script&lang=js"
export * from "./youjiao.vue?vue&type=script&lang=js"
import style0 from "./youjiao.vue?vue&type=style&index=0&id=47cb938f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb938f",
  null
  
)

export default component.exports